import {
  Box,
  Button,
  Skeleton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import { useTheme } from "@mui/material/styles";
import AppDialog from "./AppDialog";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";

export default function PreviewDialog({
  open,
  onClose,
  title = "Vista previa del archivo",
  subtitle = "Revise el contenido antes de continuar.",
  url,
  html,
  loading = false,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      icon={<AttachFileOutlinedIcon />}
      maxWidth="lg"
      fullScreenMobile
      stickyHeader
      contentSx={{ p: 0, overflow: "hidden" }}
      actions={
        !isMobile ? (
          <Button
            onClick={onClose}
            sx={{
              borderRadius: 2.5,
              fontWeight: 900,
              textTransform: "none",
              px: 2.4,
            }}
          >
            Cerrar
          </Button>
        ) : null
      }
    >
      {loading ? (
        <Box sx={{ p: 2 }}>
          <Skeleton
            variant="rounded"
            height={isMobile ? 420 : 680}
            sx={{ borderRadius: isMobile ? 0 : 3 }}
          />
        </Box>
      ) : html ? (
        <iframe
          srcDoc={html}
          sandbox=""
          style={{
            width: "100%",
            height: isMobile ? "calc(100vh - 72px)" : "82vh",
            border: 0,
            display: "block",
            background: "#fff",
          }}
          title="preview"
        />
      ) : url ? (
        <iframe
          src={url}
          style={{
            width: "100%",
            height: isMobile ? "calc(100vh - 72px)" : "82vh",
            border: 0,
            display: "block",
          }}
          title="preview"
        />
      ) : (
        <Box
          sx={{
            minHeight: isMobile ? 320 : 480,
            display: "grid",
            placeItems: "center",
            p: 3,
            textAlign: "center",
          }}
        >
          <Box>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: 3,
                display: "grid",
                placeItems: "center",
                mx: "auto",
                mb: 1.5,
                bgcolor: "rgba(0,0,0,0.05)",
                color: "text.secondary",
              }}
            >
              <InsertDriveFileRoundedIcon sx={{ fontSize: 28 }} />
            </Box>

            <Typography sx={{ fontWeight: 900, mb: 0.5 }}>
              No se pudo cargar el archivo
            </Typography>

            <Typography variant="body2" sx={{ opacity: 0.72 }}>
              Intente nuevamente o verifique que el archivo exista.
            </Typography>

            {isMobile && (
              <Button
                onClick={onClose}
                sx={{
                  mt: 2,
                  borderRadius: 2.5,
                  fontWeight: 900,
                  textTransform: "none",
                }}
              >
                Cerrar
              </Button>
            )}
          </Box>
        </Box>
      )}
    </AppDialog>
  );
}
